import { Controller } from "@hotwired/stimulus"
import AOS from 'aos';

export default class extends Controller {
  static targets = []

  connect() {
    this.setup_aos()
  }

  setup_aos() {
    AOS.init({
      offset: 200,
      duration: 900,
      easing: 'ease-in-out',
      delay: 100,
      once: true,
    });
  }
}

